module.exports = __webpack_public_path__ + "img/mailbox.2d9d6931.svg";